<template>
  <div>
    <div class="row">
      <div class="col-12">
        <page-header
          :page="page"
          @onReturn="() => $router.back()"
          :has-return="true"
        />
      </div>
    </div>
    <div class="row">
      <div class="col">
        <filter-manager
          :display-advanced="false"
          class="search-bar"
          items-container-class="flex-wrap"
          search-icon="fa fa-sync"
          search-text="Procesar"
          search-container-class="btn-process"
          v-model="model.search.filters"
          :filters="filterManagerConfig"
          @search="onHandlerSearch"
          ref="filterRef"
        />
      </div>
    </div>
  </div>
</template>

<script>
import PageHeader from 'PageHeader'
import FilterManager from 'FilterManager'
import AcademicYearServices from '@/services/api/academicyear.api'
import LocationServices from '@/services/api/location.api'
import ReportServices from '@/modules/report/api'
import DocumentServices from '@//modules/report/document'

export default {
  components: {
    PageHeader,
    FilterManager,
  },
  data: () => ({
    page: {
      icon: 'fas fa-clipboard-list-check',
      title: 'Informe de Proceso de Registros',
      routes: ['Informes', 'Informe de Proceso de Registros'],
    },
    model: {
      search: {
        collections: {
          academicYears: [],
          months: [],
          centers: [],
        },
        filters: {
          academicYear: null,
          month: null,
          center: null,
        },
      },
    },
  }),
  computed: {
    filterManagerConfig() {
      return [
        {
          name: 'academicYear',
          component: 'custom-drop-down',
          fieldKey: 'id',
          fieldName: 'name',
          label: 'Año Académico',
          placeholder: 'Seleccionar',
          error: 'Favor seleccionar un año académico.',
          validations: 'required',
          clearable: false,
          options: this.model.search.collections.academicYears,
          value: this.model.search.filters.academicYear,
          onChanged: this.onChangeAcademicYear,
          class: 'col-md-3',
        },
        {
          name: 'center',
          component: 'custom-drop-down',
          fieldKey: 'id',
          fieldName: 'name',
          label: 'Centro',
          placeholder: 'Seleccionar',
          options: this.model.search.collections.centers,
          value: this.model.search.filters.center,
          class: 'col-md-3',
          disabled: this.model.search.collections.centers.length <= 0,
        },
        {
          name: 'month',
          component: 'custom-drop-down',
          fieldKey: 'id',
          fieldName: 'name',
          label: 'Mes',
          placeholder: 'Seleccionar',
          options: this.model.search.collections.months,
          value: this.model.search.filters.month,
          class: 'col-md-3',
          disabled: this.model.search.collections.months.length <= 0,
          onChanged: this.onChangeMonth,
        },
      ]
    },
  },
  async mounted() {
    await this.setFilters()
  },
  methods: {
    async onChangeAcademicYear() {
      this.model.search.filters.month = null
      this.model.search.filters.center = null

      await this.getMonths();
      await this.getCenters();
    },
    async setFilters() {
      await AcademicYearServices.getExistingPeisAcademicYears().then(
        (res) => (this.model.search.collections.academicYears = res.data)
      )
    },
    async onHandlerSearch() {
      this.process();
    },
    async process() {
      if (
        this.hasValue(this.model.search.filters.academicYear)
      ) {
        await ReportServices.getReport('studenttrackingentry', {
          academicYearId: this.model.search.filters.academicYear?.id,
          centerId: this.model.search.filters.center?.id,
          monthNumber: this.model.search.filters.month?.id,
        }).then((res) => DocumentServices.Download(res.data));
      }
    },
    async getMonths() {
      this.model.search.collections.months  = (
        await AcademicYearServices.getMonthsInAcademicYear(
          this.model.search.filters.academicYear?.id
        )
      ).data;
    },
    async getCenters() {
      await LocationServices.getCenters({
        academicYearId: this.model.search.filters.academicYear?.id,
      }).then((res) => (this.model.search.collections.centers = res.data));
    },
    hasValue(paramValue) {
      return paramValue !== null && paramValue !== undefined
    },
  },
}
</script>
